import { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

import { useUserStore } from '@/stores/user';

export function resolveRedirect(to: RouteLocationNormalized): RouteLocationRaw {
	const redirect = to.query.redirect as string | undefined;
	if (redirect?.startsWith('/search?')) {
		const query = Object.fromEntries(new URLSearchParams(redirect.slice('/search?'.length)));
		return { name: 'search', query };
	}
	return { name: 'search' };
}

export function ifAuthenticated(_to: RouteLocationNormalized): boolean | RouteLocationRaw {
	const userStore = useUserStore();
	if (!userStore.isAuthenticated) {
		// TODO: Enable this once we have a real login page
		// return { name: 'login', query: { r: to.fullPath } };
		return { name: 'home' };
	}
	return true;
}

export function ifNotAuthenticated(_to: RouteLocationNormalized): boolean | RouteLocationRaw {
	const userStore = useUserStore();
	if (userStore.isAuthenticated) {
		return resolveRedirect(_to);
	}
	return true;
}

export function ifDifferentSchool(_to: RouteLocationNormalized): boolean | RouteLocationRaw {
	const userStore = useUserStore();

	if (!userStore.isAuthenticated) {
		return true;
	}

	const schoolIdParam = _to.query.schoolid?.toString();
	const sessionSchoolId = userStore.user?.login_session?.school_id;

	if (sessionSchoolId?.toString() !== schoolIdParam) {
		return true;
	}

	return resolveRedirect(_to);
}
